import { TasksScreen } from '@/features/tasks/components/tasks-screen';

export function TasksPage() {
  return <TasksScreen />;
}
